import Snackbar from "@/components/widgets/notifications/Snackbar.vue";

export default {
  install: (Vue) => {
    const snackData = Vue.observable({
      status: false,
      type: "",
      title: "",
      description: "",
    });

    Vue.prototype.$snackbar = {
      setParams(type, title, description) {
        snackData.status = true;
        snackData.type = type;
        snackData.title = title;
        snackData.description = description;
      },

      getData() {
        return snackData;
      },
    };

    Vue.component("SnackbarAlert", Snackbar);
  },
};
